<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="customerInfo"></ng-container>
            <ng-container *ngTemplateOutlet="stockPlaceInfo"></ng-container>
            <tt-button ttText="businesscoonboarding_save" (ttClick)="saveChanges()" ttIcon="fas fa-sync-alt" ttType="success" [ttLoading]="saving"></tt-button>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="businesscoonboarding_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="p-5">
                        <ng-container *ngTemplateOutlet="customerInfo"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="p-5">
                        <ng-container *ngTemplateOutlet="stockPlaceInfo"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>

        <tt-card class="col-xs-12 p-5">
            <tt-button ttText="businesscoonboarding_save" (ttClick)="saveChanges()" ttIcon="fas fa-sync-alt" ttType="success" [ttLoading]="saving"></tt-button>
        </tt-card>
    </div>
</tt-page>

<ng-template #customerInfo>
    <ng-container *ngIf="!!page">
        <div [hidden]="page.cust_no !== '0'">
            <tt-input ttLabel="cust_no" [ttModel]="page.cust_no" ttReadonly></tt-input>
            <tt-search ttLabel="cust_name" [(ttModel)]="page.cust_name" [ttSearch]="searchCustomerNames" (ttOnSelected)="onCustomerNameSelected($event)" (ttOnClear)="onCustomerNameSelected()" [ttButtons]="customerSearchButtons"></tt-search>
        </div>

        <div [hidden]="page.cust_no === '0'">
            <tt-input ttLabel="cust_no" [ttModel]="page.cust_no" ttReadonly [ttButtons]="customerButtons"></tt-input>
            <tt-search ttLabel="cust_name" [(ttModel)]="page.cust_name" [ttSearch]="searchCustomerNames" (ttOnSelected)="onCustomerNameSelected($event)" (ttOnClear)="onCustomerNameSelected()"></tt-search>
        </div>

        <tt-textarea ttLabel="cust_address" [(ttModel)]="page.cust_address"></tt-textarea>
        <tt-input ttLabel="org_no" [ttModel]="page.org_no" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #stockPlaceInfo>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="valuta_id" [ttModel]="page.valuta_id" ttReadonly></tt-input>
        <tt-input ttLabel="stockplace_name" [(ttModel)]="page.stockplace_name" ttRequired></tt-input>
        <tt-select ttLabel="businessco_no_copy_from" [(ttModel)]="page.businessco_no_copy_from" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name" ttRequired></tt-select>
    </ng-container>
</ng-template>
